import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { ToastrService } from "../../components/_toastr/toastr.service";
import { HttpService } from "../../services/http.service";
import { ToolsService } from "../../services/tools.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Component({
  selector: "forgot-dialog",
  templateUrl: "./forgot-dialog.html",
  standalone: false,
})
export class ForgotDialog {
  public sEmail = "";
  public bLoad: boolean;

  constructor(
    public _dr: MatDialogRef<ForgotDialog>,
    private _http: HttpClient,
    private _tools: ToolsService,
    private _toastr: ToastrService
  ) {}

  onNoClick(): void {
    this._dr.close();
  }

  onClick(): void {
    if (this.sEmail != "") {
      this.bLoad = true;
      const params = {
        Login_ID: 0,
        Login_Mail: this.sEmail,
      };
      const header = new HttpHeaders({ "Content-Type": "application/json" });
      const httpOptions = { headers: header, params: params };

      this._http.post<any>("/base/api/login/reset", httpOptions).subscribe(
        (result) => {
          if (result.isOk) {
            this.onNoClick();
            this._toastr.show({
              title: "Félicitation",
              message:
                "Un email vous a été envoyé avec un nouveau mot de passe",
              type: "success",
            });
          } else {
            this._toastr.show({
              title: "Erreur",
              message: result.message,
              type: "error",
            });
            this.bLoad = false;
          }
        },
        (error) => {
          this._tools.showHttpError(error);
          this.bLoad = false;
        }
      );
    } else {
      this._toastr.show({
        title: "Erreur",
        message: "Veuillez renseigner votre adresse mail",
        type: "error",
      });
    }
  }
}
